
<topaz-toast useIcon>
  <div toast-content>
    <b *ngIf="data.url!=='copy certificate link'">Certificate link generated!</b>
    <b *ngIf="data.url==='copy certificate link'">Copied to clipboard!</b>
    
  </div>
  <div *ngIf="data.url!=='copy certificate link'"toast-action mat-button color="primary" [cdkCopyToClipboard]="data.url"  (cdkCopyToClipboardCopied)="handleCopy()" style="color:#0F6CBD;cursor:pointer;font-size:16px;line-height:100%;letter-spacing:0px">{{ isCopied ? 'Link copied!' : 'Copy link' }}</div>
</topaz-toast>
  